export default __webpack_public_path__ + "static/media/p9.11e18f07.jpeg";